import React from 'react'
// import { Link } from 'react-router-dom';

const FooterDisplay = () => {
  return (
    <div>        
        <a href="/info" target="_blank" rel="noopener noreferrer">¿Cómo funciona MiComedor?</a>
    </div>
  )
}

export default FooterDisplay